module.exports = __webpack_public_path__ + "static/media/landing-2.4b5c7ce6.png";